<template>
  <div>
    <label class="control-label">Unidade de Saúde</label>
    <Select v-model="uor" :showOptionEmpty="false" :options="uors" @input="update" />
  </div>
</template>

<script>
import Select from '@/components/common/Select'
import { request } from '@/request'
export default {
  components: {
    Select,
  },
  props: {
    value: {
      type: String,
    },
    referencia: {
      type: String,
      required: true
    }
  },
  created() {
    if (this.referencia) this.loadAndSetUors()
  },
  data() {
    return {
      uors: [
        {
          label: 'Selecione a unidade de saúde',
          value: null,
        },
      ],
      uor: null,
    }
  },
  watch: {
    value(value) {
      this.uor = value
    },
    referencia(value) {
      if (value) this.loadAndSetUors()
      else this.reset()
    }
  },
  methods: {
    loadAndSetUors() {
      request
        .get(`escala/listar-unidade-usuario-disponivel-escala?referencia=${this.referencia}`)
        .then(this.setUors)
        .catch(e => {
          console.log(e)
        })
    },
    setUors({ data }) {
      if (data.length === 0) {
        this.uors = [{ label: 'Não há nenhuma unidade disponivel para lançamento nesta referência!', value: null }]
        this.uor = null
        this.$toastr.w('As escalas com está referência devem estar em analise!')
        return
      } else {
        this.uors = data.map(({ uor_sigla, uor_nome }) => {
          return {
            value: `${uor_sigla}|${uor_nome}`,
            label: `${uor_sigla} | ${uor_nome}`
          }
        })

        this.uor = this.uors[0].value
        this.update()
      }
    },
    update() {
      this.$emit('input', this.uor)
    },
    reset() {
      this.uors = [{
        label: 'Selecione a unidade de saúde',
        value: null,
      }]
      this.uor = null
    }
  },
}
</script>

<style scoped>
div {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  margin-bottom: 10px;
}

select {
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/SelectUOR.vue